<section class="pl-error-page__message pl-error-state">
  <se-fe-empty-state [seFeDataTitle]="'INVALID_LISTENER.' + path + '_title' | translate">
    <se-fe-icon seFeEmptyStateIcon seFeDataName="lock_thin" seFeDataSize="950" seFeDataColor="gray-900"></se-fe-icon>
    {{ 'INVALID_LISTENER.' + path + '_message' | translate }}
  </se-fe-empty-state>
</section>
